import React, { useState } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import { Html } from '@react-three/drei';

const LabelComponent = ({ position, text }) => {
    const { camera } = useThree();
    const [isVisible, setIsVisible] = useState(true);

    useFrame(() => {
        // Example condition: Hide labels if the camera's zoom is less than a certain level
        // This threshold will depend on your specific camera setup and scene scale
        const zoomThreshold = 105;

        // For OrthographicCamera
        // if (camera.isOrthographicCamera) {
        setIsVisible(camera.zoom > zoomThreshold);
        // }

        // For PerspectiveCamera, you might use the distance to the camera
        // as your condition instead of the zoom level.
        // const distanceThreshold = 10;
        // const distance = camera.position.distanceTo(label.point); // Assuming label.point is a THREE.Vector3
        // setIsVisible(distance < distanceThreshold);
    });

    return isVisible ? (
        <Html position={position} occlude center>
            <div style={{ textTransform: 'capitalize', background: '#151520', color: 'white', padding: '6px 8px', borderRadius: '7px', whiteSpace: 'nowrap' }}>
                {text}
            </div>
        </Html>
    ) : null;
};

export default LabelComponent;
